import React, { useState, useEffect } from "react";
import {
  GridToolbarContainer,
  GridToolbarColumnsButton,
  GridToolbarFilterButton,
  GridToolbarExport,
  GridToolbarDensitySelector,
} from "@mui/x-data-grid";
import { DataGrid } from "@mui/x-data-grid";
import Button from "@mui/material/Button";
import { getGoDaddyCreds, deleteGoDaddyCred } from "../../api/requests";
import Loader from "../Loader";
import CreateAccountDialog from "./CreateAccountDialog";
import LoadingButton from "@mui/lab/LoadingButton";
import { useSelector } from "react-redux";

const GoDaddyPanel = () => {
  function CustomToolbar() {
    return (
      <div
        style={{
          display: "flex",
          flexDirection: "row",
          justifyContent: "space-between",
        }}
      >
        <GridToolbarContainer>
          <GridToolbarColumnsButton />
          <GridToolbarFilterButton />
          <GridToolbarDensitySelector />
          <GridToolbarExport />
        </GridToolbarContainer>
        <Button
          variant="contained"
          color="primary"
          size="small"
          style={{ margin: 10 }}
          onClick={() => setOpen(true)}
        >
          Add Account
        </Button>
      </div>
    );
  }

  const [data, setData] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [open, setOpen] = useState(false);
  const [loadingDelete, setLoadingDelete] = useState(false);
  const [selectedUid, setSelectedUid] = useState("");
  const [shouldRender, setShouldRender] = useState(false);

  const token = useSelector((state) => state.auth.token);

  async function fetchData() {
    setIsLoading(true);
    let tempData = await getGoDaddyCreds(token);
    setIsLoading(false);
    setData(
      tempData.map((user, index) => {
        return { ...user, id: index + 1 };
      })
    );
  }

  useEffect(() => {
    if (token !== "" && open === false) {
      fetchData();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [token, open, shouldRender]);

  const handleDelete = async (uid) => {
    const isConfirmed = window.confirm("Are you sure you want to delete?");
    if (isConfirmed) {
      setSelectedUid(uid);
      setLoadingDelete(true);
      const ans = await deleteGoDaddyCred(token, uid);
      setLoadingDelete(false);
      setSelectedUid("");
      if (ans) {
        alert("account credentials were deleted");
        setShouldRender((prev) => !prev);
      }
    }
  };

  const columns = [
    { field: "id", headerName: "ID", width: 90 },
    {
      field: "apiKey",
      headerName: "API Key",
      width: 300,
    },
    {
      field: "apiSecret",
      headerName: "API Secret",
      width: 220,
    },
    {
      field: "customerId",
      headerName: "Customer ID",
      width: 300,
    },
    {
      field: "delete",
      headerName: "Delete Credentials",
      width: 150,
      description: "This column has a render cell and is not sortable.",
      sortable: false,
      renderCell: (params) => (
        <div>
          <LoadingButton
            variant="contained"
            color="error"
            size="small"
            style={{ marginLeft: 16 }}
            onClick={() => handleDelete(params.row.uid)}
            loading={loadingDelete && selectedUid === params.row.uid}
            data-testid={"delete-godaddy-btn"}
          >
            delete
          </LoadingButton>
        </div>
      ),
    },
  ];

  return (
    <>
      {isLoading && <Loader />}
      <div
        style={{
          height: 320,
          width: "100%",
          visibility: isLoading ? "hidden" : "visible",
        }}
      >
        <DataGrid
          rows={data}
          columns={columns}
          pageSize={3}
          rowsPerPageOptions={[3]}
          disableSelectionOnClick
          components={{ Toolbar: CustomToolbar }}
          aria-label={"GoDaddy Accounts"}
          disableVirtualization
        />
      </div>
      <CreateAccountDialog open={open} setOpen={setOpen} />
    </>
  );
};

export default GoDaddyPanel;
